import { useEffect } from 'react';

import { setToastInstance } from '@/utils/QueryClient/QueryClient';

import { useToast } from '@/context/ToastContext';

/**
 * Componente responsável por conectar o ToastContext ao QueryClient
 * Deve ser renderizado dentro do ToastProvider para ter acesso ao useToast()
 */
export const ToastInitializer = () => {
  const toast = useToast();

  useEffect(() => {
    // Passa a instância do toast para o QueryClient
    setToastInstance(toast);
  }, [toast]);

  // Componente não renderiza nada
  return null;
};
